import axios from 'axios';
import gsap from 'gsap';

function loadMore() {
    const loadMoreBtn = document.querySelectorAll('.load-more-listing + .load-more')
    const firstListings = document.querySelectorAll('.load-more-listing .listing-page:first-of-type')

    if (!loadMoreBtn) return

    window.addEventListener('load', () => {
        firstListings.forEach(listing => {
            if (listing.children.length !== 0) loadListing(listing.children)
        })
    })

    loadMoreBtn.forEach(button => button.addEventListener('click', (e) => {
        const listing = e.target.previousElementSibling 
        const loading = e.target.nextElementSibling
        const params = new URLSearchParams();
        const postType = listing.dataset.posttype;
        let currentPage = listing.dataset.page;
        let maxPages = listing.dataset.max;

        params.append('action', 'load_more')
        params.append('current_page', currentPage)
        params.append('max_page', maxPages)
        params.append('post_type', postType)

        if (postType === 'event') {
            params.append('event_type', listing.dataset.eventtype)
        }

        e.target.style.display = 'none'
        loading.style.display = 'block'

        axios.post('/wp-admin/admin-ajax.php', params)
        .then(resp => {
            const newListings = document.createElement('div')
            newListings.classList.add('listing-page')
            newListings.insertAdjacentHTML("beforeend", resp.data.data)
            listing.appendChild(newListings)
            listing.dataset.page++;

            if (listing.dataset.page == listing.dataset.max) {
                e.target.style.display = 'none'
              } else {
                e.target.style.display = 'block'
              }

            loading.style.display = 'none'
            loadListing(newListings.querySelectorAll('a'))
        })
    }))

}

function loadListing(newListing) {
    gsap.fromTo(newListing, { 
        y: 60,
    }, 
    { 
        y: 0,
        opacity: 1, 
        duration: 0.5,
        stagger: 0.2,
        ease: "power1.out",
    }
);

}

window.addEventListener('DOMContentLoaded', () => {
    loadMore()
})